import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { darken } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import Portal from "../ui/portal.js";
import PortalAppBar from "../ui/portalAppBar.js";
import PortalGridContent from "../ui/portalGridContent.js";
import BotpressAssessments from "../widgets/botpressAssessments.js";
import BotpressFlaggedConversations from "../widgets/botpressFlaggedConversations.js";
import BotpressTestHarness from "../widgets/botpressTestHarness.js";
import BotpressUserFeedback from "../widgets/botpressUserFeedback.js";

const BotpressTestHarnessPortal = props => {
  const { botpressBotODM } = props;
  const theme = useTheme();

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundSize: "cover",
        backgroundColor: darken(theme.palette.commonground.main, 0.4),
      }}
    >
      <PortalAppBar title="Test Harness" botpressStyle={true} />
      <PortalGridContent>
        <Grid item size={{ xs: 12, sm: 6, lg: 5 }}>
          {botpressBotODM && <BotpressTestHarness widgetSize={"full"} minHeight={"100%"} />}
        </Grid>
        <Grid item size={{ xs: 12, sm: 6, lg: 7 }}>
          <BotpressAssessments />
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <BotpressUserFeedback />
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <BotpressFlaggedConversations />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  botpressBotODM: state.botpressSession.botpressBotODM,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BotpressTestHarnessPortal));
